const BI_TYPE = {
  /** 심볼형 */
  SYMBOL: 'Symbol',
  /** 프로필형 */
  PROFILE: 'Profile',
  /** 심볼 + 타입 로고 > 배경색 없음 */
  TEXT: 'TextPositive',
  /** 심볼 + 타입 로고 > 배경색 있음 */
  TEXT_WHITE: 'TextNegative',
  /** (카드 전용) 세로 플레이트 + 프로필 로고 */
  VERTICAL_PROFILE_PLATE: 'Plate',
  /** (카드 전용) 세로 플레이트 + IC chip */
  VERTICAL_IC_PLATE: 'IcCard'
};
const DEFAULT_SIZE = 42;
const DEFAULT_PLATE_SIZE = [38, 60];

export { BI_TYPE, DEFAULT_PLATE_SIZE, DEFAULT_SIZE };
